module.exports = __webpack_public_path__ + "static/media/TRACK1.ec75a7c8.MOV";